import script from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=js"

import "./BaseInputNumber.vue?vue&type=style&index=0&id=317d3b98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317d3b98"]])

export default __exports__